namespace Matrix.Data {
    export interface DataReportExecuteRequest extends Serenity.ListRequest {
        ReportKey?: string;
        Params?: { [key: string]: any };
        TimeZoneOffset?: number;
    }
}
